var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "rgb(168, 176, 185)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 6,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v8c0 1.7 2.7 3 6 3s6-1.3 6-3V6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10c0 1.7 2.7 3 6 3s6-1.3 6-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14c0 1.7 2.7 3 6 3s6-1.3 6-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage_icon.e305a0956e57a827e85721a405310a10.svg";
export { ForwardRef as ReactComponent };